import { __decorate, __param } from 'tslib';
import { Inject, Input, HostBinding, Directive, NgModule } from '@angular/core';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import { Observable } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
let TuiWrapperDirective = class TuiWrapperDirective {
    constructor(mode$) {
        this.mode$ = mode$;
        this.disabled = false;
        this.readOnly = false;
        // TODO: Rename to `hover` in 3.0
        this.hovered = null;
        // TODO: Rename to `active` in 3.0
        this.pressed = null;
        this.focused = false;
        this.invalid = false;
        this.appearance = '';
    }
    get computedInvalid() {
        return !this.disabled && !this.readOnly && this.invalid;
    }
    get computedFocused() {
        return this.focused && !this.disabled;
    }
    get interactiveState() {
        if (this.disabled) {
            return "disabled" /* Disabled */;
        }
        if (this.readOnly) {
            return "readonly" /* Readonly */;
        }
        if (this.pressed) {
            return "pressed" /* Pressed */;
        }
        if (this.hovered) {
            return "hovered" /* Hovered */;
        }
        return null;
    }
    get noHover() {
        return this.readOnly || this.hovered === false;
    }
    get noActive() {
        return this.readOnly || this.pressed === false;
    }
};
TuiWrapperDirective.ɵfac = function TuiWrapperDirective_Factory(t) { return new (t || TuiWrapperDirective)(ɵngcc0.ɵɵdirectiveInject(TUI_MODE)); };
TuiWrapperDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiWrapperDirective, selectors: [["tui-wrapper"], ["", "tuiWrapper", ""]], hostVars: 10, hostBindings: function TuiWrapperDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.data-mode.attr", function TuiWrapperDirective___data_mode_attr_HostBindingHandler() { return ctx.mode$; });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-appearance", ctx.appearance)("data-state", ctx.interactiveState);
        ɵngcc0.ɵɵclassProp("_invalid", ctx.computedInvalid)("_focused", ctx.computedFocused)("_no-hover", ctx.noHover)("_no-active", ctx.noActive);
    } }, inputs: { disabled: "disabled", readOnly: "readOnly", hovered: "hovered", pressed: "pressed", focused: "focused", invalid: "invalid", appearance: "appearance" }, features: [ɵngcc0.ɵɵProvidersFeature([MODE_PROVIDER])] });
TuiWrapperDirective.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] }
];
__decorate([
    Input()
], TuiWrapperDirective.prototype, "disabled", void 0);
__decorate([
    Input()
], TuiWrapperDirective.prototype, "readOnly", void 0);
__decorate([
    Input()
], TuiWrapperDirective.prototype, "hovered", void 0);
__decorate([
    Input()
], TuiWrapperDirective.prototype, "pressed", void 0);
__decorate([
    Input()
], TuiWrapperDirective.prototype, "focused", void 0);
__decorate([
    Input()
], TuiWrapperDirective.prototype, "invalid", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-appearance')
], TuiWrapperDirective.prototype, "appearance", void 0);
__decorate([
    HostBinding('class._invalid')
], TuiWrapperDirective.prototype, "computedInvalid", null);
__decorate([
    HostBinding('class._focused')
], TuiWrapperDirective.prototype, "computedFocused", null);
__decorate([
    HostBinding('attr.data-state')
], TuiWrapperDirective.prototype, "interactiveState", null);
__decorate([
    HostBinding('class._no-hover')
], TuiWrapperDirective.prototype, "noHover", null);
__decorate([
    HostBinding('class._no-active')
], TuiWrapperDirective.prototype, "noActive", null);
TuiWrapperDirective = __decorate([ __param(0, Inject(TUI_MODE))
], TuiWrapperDirective);

let TuiWrapperModule = class TuiWrapperModule {
};
TuiWrapperModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiWrapperModule });
TuiWrapperModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiWrapperModule_Factory(t) { return new (t || TuiWrapperModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiWrapperDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-wrapper, [tuiWrapper]',
                providers: [MODE_PROVIDER],
                host: {
                    '($.data-mode.attr)': 'mode$'
                }
            }]
    }], function () { return [{ type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }]; }, { disabled: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], hovered: [{
            type: Input
        }], pressed: [{
            type: Input
        }], focused: [{
            type: Input
        }], invalid: [{
            type: Input
        }], appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-appearance']
        }], computedInvalid: [{
            type: HostBinding,
            args: ['class._invalid']
        }], computedFocused: [{
            type: HostBinding,
            args: ['class._focused']
        }], interactiveState: [{
            type: HostBinding,
            args: ['attr.data-state']
        }], noHover: [{
            type: HostBinding,
            args: ['class._no-hover']
        }], noActive: [{
            type: HostBinding,
            args: ['class._no-active']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiWrapperModule, { declarations: [TuiWrapperDirective], exports: [TuiWrapperDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiWrapperModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiWrapperDirective],
                exports: [TuiWrapperDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiWrapperDirective, TuiWrapperModule };

//# sourceMappingURL=taiga-ui-core-directives-wrapper.js.map